// extracted by mini-css-extract-plugin
export default {"cell":"AccordionCellNew__cell--iPu"};